var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/20d49fd09379348ab5a99714522f324d.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/74b57a0aab89075f611af0ee1b1e1454.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a3bae7cf7079779ce3d53f08d527a46c.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e5071f873566cb3ec79b2c9a60f7237a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    